<template>
        <form>
            <ui-container>
                <ui-form-section title="Basic Details" subtitle="Provide the main details of the labour rate in this section." class="py-8 border-b">
                    <ui-select-searchable
                      label="Group Name"
                      name="group_name"
                      v-model="form.group_name"
                      class="xl:col-span-6"
                      placeholder="Horizontal, Upstands etc"
                      :error="form.errors.get('group_name')"
                      :options="labourRateGroups"
                      :create-option="name => ({ value: name, label: name })"
                    ></ui-select-searchable>
                    <ui-input label="Name" name="name" v-model="form.name" class="xl:col-span-6" placeholder="Ply, Felt etc" :error="form.errors.get('name')"></ui-input>

                    <ui-input label="Unit Of Measure" name="uom" v-model="form.uom" class="xl:col-span-6" placeholder="m2, lm etc" :error="form.errors.get('uom')"></ui-input>
                    <ui-input label="Unit Output Per Hour" name="unit_per_hour" v-model="form.unit_per_hour" class="xl:col-span-6" placeholder="5, 25, 3 etc" :error="form.errors.get('unit_per_hour')"></ui-input>
                </ui-form-section>

                <ui-form-section v-if="!item || item.can_view.buy_rate || item.can_view.sell_rate" title="Pricing Details" subtitle="We need to know the buy and sell day rate for this labour type" class="py-8 border-b">
                  <ui-input v-if="!item || item.can_view.buy_rate" label="Buy Day Rate" name="buy_day_rate" v-model="form.buy_day_rate" class="xl:col-span-6" placeholder="150.00, 250.00 etc" :error="form.errors.get('buy_day_rate')"></ui-input>
                  <ui-input v-if="!item || item.can_view.sell_rate" label="Sell Day Rate" name="sell_day_rate" v-model="form.sell_day_rate" class="xl:col-span-6" placeholder="150.00, 250.00 etc" :error="form.errors.get('sell_day_rate')"></ui-input>

                  <ui-input v-if="!item || item.can_view.buy_rate" label="Buy Hours Per Day" name="buy_hours_in_shift" v-model="form.buy_hours_in_shift" class="xl:col-span-6" placeholder="6, 7, 8 etc" :error="form.errors.get('buy_hours_in_shift')"></ui-input>
                  <ui-input v-if="!item || item.can_view.sell_rate" label="Sell Hours Per Day" name="sell_hours_in_shift" v-model="form.sell_hours_in_shift" class="xl:col-span-6" placeholder="6, 7, 8 etc" :error="form.errors.get('sell_hours_in_shift')"></ui-input>
                </ui-form-section>

                <ui-data-grid class="mt-5">
                  <labour-rates-rate-card
                      v-if="(item && item.can_view.buy_rate) || canViewBuyRate"
                      title="Buy Rates"
                      subtitle="The costs that you buy this type of labour in for."
                      :uom="form.uom"
                      :unitsPerHour="parseFloat(form.unit_per_hour)"
                      :hoursInDay="parseFloat(form.buy_hours_in_shift)"
                      :dailyRate="parseFloat(form.buy_day_rate)"
                  />
                  <labour-rates-rate-card
                      v-if="(item && item.can_view.sell_rate) || canViewSellRate"
                      title="Sell Rates"
                      subtitle="The costs that you sell this type of labour for."
                      :uom="form.uom"
                      :unitsPerHour="parseFloat(form.unit_per_hour)"
                      :hoursInDay="parseFloat(form.sell_hours_in_shift)"
                      :dailyRate="parseFloat(form.sell_day_rate)"
                  />
                </ui-data-grid>
            </ui-container>

            <ui-container class="py-4 flex justify-end space-x-6">
                <ui-button-new v-if="editMode" @click="edit(false)">Cancel</ui-button-new>
                <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
                <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">
                    {{ editMode ? 'Save' : 'Create' }}
                </ui-button-new>
            </ui-container>
        </form>
</template>

<script>
import {LabourRate} from "@models";

export default {
  props: {
    item: Object,
    edit: Function,
    addItem: Function,
    itemAdded: {type: Function, required: false, default: function(){}},
    buyHoursInShift: {type: Number, required: true, default: 7},
    sellHoursInShift: {type: Number, required: true, default: 8},
    buyDayRate: {type: Number, required: true, default: 175.00},
    sellDayRate: {type: Number, required: true, default: 200.00},
    canViewBuyRate : Boolean,
    canViewSellRate : Boolean,
  },
    data () {
        const initialData = this.item
            ? this.item.getFormAttributes()
            : {
              'uom': 'm2',
              'buy_hours_in_shift': this.buyHoursInShift,
              'sell_hours_in_shift': this.sellHoursInShift,
              'unit_per_hour': 5,
              'buy_day_rate': this.buyDayRate,
              'sell_day_rate': this.sellDayRate
            }

        return {
            labourRateGroups: [],
            form: new Form(initialData, async (form) => {
                if (this.editMode) {
                    await this.item.update(form.export())
                  this.edit(false)
                } else {
                  const labourRate = await LabourRate.create(form.export())
                  this.addItem(labourRate, 0)
                  this.itemAdded(labourRate);

                  form.reset()
                }
            }),
        }
    },
  computed: {
    editMode() {
      return !!this.item
    },
  },
  async mounted () {
    this.labourRateGroups = await LabourRate.groups()
  },
}
</script>
